import { Input } from "../../../../shadcn/components/ui/Input";
import { Label } from "../../../../shadcn/components/ui/Label";
import { Checkbox } from "../../../../shadcn/components/ui/Checkbox";
import { Button } from "../../../../shadcn/components/ui/Button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../../shadcn/components/ui/Card";
import { useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import the default styles for Toastify


export function RentalApplication() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  
  

  const propertyId = queryParams.get("propertyId"); // Get propertyId
  const propertyFormId = queryParams.get("purchaseId"); // Get purchaseId

  console.log("Property ID:", propertyId);
  console.log("Purchase ID:", propertyFormId);

  const [formData, setFormData] = React.useState({

    propertyId,
    propertyFormId,

    rentalapplicationdata: {
      details: {
        date: "",
        firstName: "",
        lastName: "",
        socialSecurity: "",
        otherLastNames: "",
        disabled: false,
        email: "",
        homePhone: "",
        workPhone: "",
        cellPhone: "",
        autoMobile: "",
        license: "",
        state: "",
        hearingFeedback: "",
      },
      employmentHistory: {
        companyName: { currentEmployer: "", previousEmployer: "" },
        address: { currentEmployer: "", previousEmployer: "" },
        phone: { currentEmployer: "", previousEmployer: "" },
        supervisor: { currentEmployer: "", previousEmployer: "" },
        position: { currentEmployer: "", previousEmployer: "" },
        datesOfEmployment: { currentEmployer: "", previousEmployer: "" },
        monthlyIncome: { currentEmployer: "", previousEmployer: "" },
      },
      rentalHistory: {
        street: { currentResidence: "", previousResidence: "" },
        cityStateZIP: { currentResidence: "", previousResidence: "" },
        landlordManager: { currentResidence: "", previousResidence: "" },
        phoneNumber: { currentResidence: "", previousResidence: "" },
        monthlyPayment: { currentResidence: "", previousResidence: "" },
        dates: { currentResidence: "", previousResidence: "" },
        leavingReason: { currentResidence: "", previousResidence: "" },
      },
      rentalHistoryBool: {
        bankruptcy: false,
        convictedFelony: false,
        rentalResidence: true,
        rentalPayment: true,
        payRent: true,
      },
      emergencyContact1: {
        firstName: "",
        lastName: "",
        mi: "",
        homePhone: "",
        workPhone: "",
        cellPhone: "",
      },
      emergencyContact2: {
        firstName: "",
        lastName: "",
        mi: "",
        homePhone: "",
        workPhone: "",
        cellPhone: "",
      },
      authorizationReleaseInformation: { signature: "", date: "" },
    },
    token: localStorage.getItem("authToken") || "", // Set token from localStorage
  });

  const api = process.env.REACT_APP_API_URL;

  const handleChange = (e) => {
    const path = e.target.getAttribute("data-path"); // Get the data-path from the input
    if (!path) {
      console.error("data-path is missing!");
      return;
    }

    const value = e.target.value; // Get the input value

    setFormData((prev) => {
      const keys = path.split("."); // Split the data-path into keys
      const updatedData = { ...prev }; // Shallow copy of the state
      let current = updatedData;

      // Navigate to the target key
      for (let i = 0; i < keys.length - 1; i++) {
        if (!current[keys[i]]) {
          current[keys[i]] = {}; // Create intermediate object if undefined
        }
        current = current[keys[i]];
      }

      // Set the final key's value
      current[keys[keys.length - 1]] = value;

      console.log("Updated formData:", updatedData); // Debug the updated state
      return updatedData; // Return the updated state
    });
  };

  // Send the data
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = formData.token || localStorage.getItem("token");

      const response = await axios.post(
        `https://silver-tlc-backend-delta.vercel.app/api/v1/propertypurchaseform/rentalapplication-request/submit`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

    toast.success("Form submitted successfully!");
  
  } catch (error) {
    toast.error("Error submitting form: " + (error.response?.data?.message || "Something went wrong"));

      if (error.response) {
        console.error("Backend response error:", error.response.data);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error setting up request:", error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  // breadcrumb
  const handleBreadcrumbClick = () => {
    navigate("/dashboard/services");
  };
  const handleBreadcrumbClick2 = () => {
    navigate(`/dashboard/propertyForm/${propertyId}`);
  };

  return (
    <div className="container mx-auto p-0">
      <form onSubmit={handleSubmit} className="space-y-8">
        <Card className="bg-gray-100">
          <CardHeader>
            {/* Breadcrumbs */}
            <div className="mb-4 text-sm">
              <button
                onClick={handleBreadcrumbClick}
                className="text-gray-500 hover:text-gray-700"
              >
                My Services
              </button>
              <span className="mx-2 text-gray-400">&gt;</span>
              <button
                onClick={handleBreadcrumbClick2}
                className="text-gray-500 hover:text-gray-700"
              >
                Property Form
              </button>
              <span className="mx-2 text-gray-400">&gt;</span>
              <span className="text-purple-600 font-medium">Rental Form</span>
            </div>

            <CardTitle className="flex gap-2">
              <svg
                width="27"
                height="28"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M25.9091 27.273H4.09093V25.9094H2.72729V4.09118H4.09093V2.72754H25.9091V4.09118H27.2727V25.9094H25.9091V27.273ZM24.5455 8.18208V5.45481H5.45457V8.18208H24.5455ZM24.5455 24.5457V10.9094H5.45457V24.5457H24.5455Z"
                  fill="#323743"
                />
              </svg>
              Rental Application
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            {/* Personal Information */}
            <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6">
              <div className="space-y-2">
                <Label htmlFor="date">Date</Label>
                <Input
                  id="date"
                  type="date"
                  name="date"
                  data-path="rentalapplicationdata.details.date"
                  value={formData.rentalapplicationdata.details.date}
                  onChange={handleChange}
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="firstName">First Name</Label>
                <Input
                  id="firstName"
                  name="firstName"
                  data-path="rentalapplicationdata.details.firstName"
                  value={formData.rentalapplicationdata.details.firstName}
                  onChange={handleChange}
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="lastName">Last Name</Label>
                <Input
                  id="lastName"
                  name="lastName"
                  data-path="rentalapplicationdata.details.lastName"
                  value={formData.rentalapplicationdata.details.lastName}
                  onChange={handleChange}
                />
              </div>
             
              <div className="space-y-2">
                <Label htmlFor="ssn">Social Security</Label>
                <Input
                  id="socialSecurity"
                  name="socialSecurity"
                  data-path="rentalapplicationdata.details.socialSecurity"
                  value={formData.rentalapplicationdata.details.socialSecurity}
                  onChange={handleChange}
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="otherNames">Other Last Names </Label>
                <Input
                  id="otherNames"
                  name="otherNames"
                  data-path="rentalapplicationdata.details.otherLastNames"
                  value={formData.rentalapplicationdata.details.otherLastNames}
                  onChange={handleChange}
                />
              </div>
              <div className="space-y-2">
                <Label>Disabled</Label>
                {/* checkbox's */}
                <div className="flex gap-4 pt-2">
                  <div className="space-y-2">
                    {/* Yes/No Checkboxes */}
                    <div className="flex gap-4 pt-2">
                      <div>
                        <input
                          type="radio"
                          id="disabledYes"
                          name="disabled"
                          data-path="rentalapplicationdata.details.disabled"
                          value="true"
                          checked={
                            formData.rentalapplicationdata.details.disabled ===
                            true
                          }
                          onChange={() =>
                            setFormData((prev) => ({
                              ...prev,
                              rentalapplicationdata: {
                                ...prev.rentalapplicationdata,
                                details: {
                                  ...prev.rentalapplicationdata.details,
                                  disabled: true,
                                },
                              },
                            }))
                          }
                        />
                        <label htmlFor="disabledYes">Yes</label>
                      </div>
                      <div>
                        <input
                          type="radio"
                          id="disabledNo"
                          name="disabled"
                          data-path="rentalapplicationdata.details.disabled"
                          value="false"
                          checked={
                            formData.rentalapplicationdata.details.disabled ===
                            false
                          }
                          onChange={() =>
                            setFormData((prev) => ({
                              ...prev,
                              rentalapplicationdata: {
                                ...prev.rentalapplicationdata,
                                details: {
                                  ...prev.rentalapplicationdata.details,
                                  disabled: false,
                                },
                              },
                            }))
                          }
                        />
                        <label htmlFor="disabledNo">No</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6">
              <div className="space-y-2">
                <Label htmlFor="email">Email Address</Label>
                <Input
                  id="email"
                  type="email"
                  name="email"
                  data-path="rentalapplicationdata.details.email"
                  value={formData.rentalapplicationdata.details.email}
                  onChange={handleChange}
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="homePhone">Home Phone</Label>
                <Input
                  id="homePhone"
                  type="tel"
                  name="homePhone"
                  data-path="rentalapplicationdata.details.homePhone"
                  value={formData.rentalapplicationdata.details.homePhone}
                  onChange={handleChange}
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="workPhone">Work Phone</Label>
                <Input
                  id="workPhone"
                  type="tel"
                  name="workPhone"
                  data-path="rentalapplicationdata.details.workPhone"
                  value={formData.rentalapplicationdata.details.workPhone}
                  onChange={handleChange}
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="cellPhone">Cell Phone</Label>
                <Input
                  id="cellPhone"
                  type="tel"
                  name="cellPhone"
                  data-path="rentalapplicationdata.details.cellPhone"
                  value={formData.rentalapplicationdata.details.cellPhone}
                  onChange={handleChange}
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="autoMobile">Auto Mobile</Label>
                <Input
                  id="autoMobile"
                  name="autoMobile"
                  data-path="rentalapplicationdata.details.autoMobile"
                  value={formData.rentalapplicationdata.details.autoMobile}
                  onChange={handleChange}
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="license">License</Label>
                <Input
                  id="license"
                  name="license"
                  data-path="rentalapplicationdata.details.license"
                  value={formData.rentalapplicationdata.details.license}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="grid gap-4 sm:grid-cols-2">
              <div className="space-y-2">
                <Label htmlFor="state">State</Label>
                <Input
                  id="state"
                  name="state"
                  data-path="rentalapplicationdata.details.state"
                  value={formData.rentalapplicationdata.details.state}
                  onChange={handleChange}
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="hearAboutUs">How did you Hear About us</Label>
                <Input
                  id="hearAboutUs"
                  name="hearAboutUs"
                  data-path="rentalapplicationdata.details.hearingFeedback"
                  value={formData.rentalapplicationdata.details.hearingFeedback}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Employment History */}
            <div>
              <h3 className="mb-7 text-xl font-semibold">Employment History</h3>
              <div className="grid gap-6 md:grid-cols-2">
                {/* Current Employer */}
                <div className="space-y-4">
                  <h4 className="font-medium">Current Employer</h4>
                  <div className="space-y-2">
                    <Label htmlFor="currentCompany">Company Name</Label>
                    <Input
                      id="currentCompany"
                      data-path="rentalapplicationdata.employmentHistory.companyName.currentEmployer"
                      value={
                        formData.rentalapplicationdata.employmentHistory
                          .companyName.currentEmployer
                      }
                      onChange={handleChange}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="currentAddress">Address</Label>
                    <Input
                      id="currentAddress"
                      data-path="rentalapplicationdata.employmentHistory.address.currentEmployer"
                      value={
                        formData.rentalapplicationdata.employmentHistory.address
                          .currentEmployer
                      }
                      onChange={handleChange}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="currentPhone">Phone</Label>
                    <Input
                      id="currentPhone"
                      type="tel"
                      data-path="rentalapplicationdata.employmentHistory.phone.currentEmployer"
                      value={
                        formData.rentalapplicationdata.employmentHistory.phone
                          .currentEmployer
                      }
                      onChange={handleChange}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="currentSupervisor">Supervisor</Label>
                    <Input
                      id="currentSupervisor"
                      data-path="rentalapplicationdata.employmentHistory.supervisor.currentEmployer"
                      value={
                        formData.rentalapplicationdata.employmentHistory
                          .supervisor.currentEmployer
                      }
                      onChange={handleChange}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="currentPosition">Position</Label>
                    <Input
                      id="currentPosition"
                      data-path="rentalapplicationdata.employmentHistory.position.currentEmployer"
                      value={
                        formData.rentalapplicationdata.employmentHistory
                          .position.currentEmployer
                      }
                      onChange={handleChange}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="currentDates">Dates of Employment</Label>
                    <Input
                      id="currentDates"
                      type="Date"
                      data-path="rentalapplicationdata.employmentHistory.datesOfEmployment.currentEmployer"
                      value={
                        formData.rentalapplicationdata.employmentHistory
                          .datesOfEmployment.currentEmployer
                      }
                      onChange={handleChange}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="currentIncome">Monthly Income</Label>
                    <Input
                      id="currentIncome"
                      type="number"
                      data-path="rentalapplicationdata.employmentHistory.monthlyIncome.currentEmployer"
                      value={
                        formData.rentalapplicationdata.employmentHistory
                          .monthlyIncome.currentEmployer
                      }
                      onChange={handleChange}
                    />
                  </div>
                </div>

                {/* Previous Employer */}
                <div className="space-y-4">
                  <h4 className="font-medium">
                    Additional or Previous Employer
                  </h4>
                  <div className="space-y-2">
                    <Label htmlFor="currentCompany">Company Name</Label>
                    <Input
                      id="currentCompany"
                      data-path="rentalapplicationdata.employmentHistory.companyName.previousEmployer"
                      value={
                        formData.rentalapplicationdata.employmentHistory
                          .companyName.previousEmployer
                      }
                      onChange={handleChange}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="currentAddress">Address</Label>
                    <Input
                      id="currentAddress"
                      data-path="rentalapplicationdata.employmentHistory.address.previousEmployer"
                      value={
                        formData.rentalapplicationdata.employmentHistory.address
                          .previousEmployer
                      }
                      onChange={handleChange}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="currentPhone">Phone</Label>
                    <Input
                      id="currentPhone"
                      type="tel"
                      data-path="rentalapplicationdata.employmentHistory.phone.previousEmployer"
                      value={
                        formData.rentalapplicationdata.employmentHistory.phone
                          .previousEmployer
                      }
                      onChange={handleChange}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="currentSupervisor">Supervisor</Label>
                    <Input
                      id="currentSupervisor"
                      data-path="rentalapplicationdata.employmentHistory.supervisor.previousEmployer"
                      value={
                        formData.rentalapplicationdata.employmentHistory
                          .supervisor.previousEmployer
                      }
                      onChange={handleChange}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="currentPosition">Position</Label>
                    <Input
                      id="currentPosition"
                      data-path="rentalapplicationdata.employmentHistory.position.previousEmployer"
                      value={
                        formData.rentalapplicationdata.employmentHistory
                          .position.previousEmployer
                      }
                      onChange={handleChange}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="currentDates">Dates of Employment</Label>
                    <Input
                      id="currentDates"
                      type="Date"
                      data-path="rentalapplicationdata.employmentHistory.datesOfEmployment.previousEmployer"
                      value={
                        formData.rentalapplicationdata.employmentHistory
                          .datesOfEmployment.previousEmployer
                      }
                      onChange={handleChange}
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="currentIncome">Monthly Income</Label>
                    <Input
                      id="currentIncome"
                      type="number"
                      data-path="rentalapplicationdata.employmentHistory.monthlyIncome.previousEmployer"
                      value={
                        formData.rentalapplicationdata.employmentHistory
                          .monthlyIncome.previousEmployer
                      }
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Rental History */}
            <div>
              <h3 className="mb-7 text-xl font-semibold">Rental History</h3>
              <div className="grid gap-6 md:grid-cols-2">
                {/* Current Residence */}
                <div className="space-y-4">
                  <h4 className="font-medium">Current Residence</h4>

                  <div className="space-y-2">
                    <Label htmlFor="currentStreet">Street</Label>
                    <Input
                      id="currentStreet"
                      data-path="rentalapplicationdata.rentalHistory.street.currentResidence"
                      value={
                        formData.rentalapplicationdata.rentalHistory.street
                          .currentResidence
                      }
                      onChange={handleChange}
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="currentCityStateZip">
                      City, State, Zip
                    </Label>
                    <Input
                      id="currentCityStateZip"
                      data-path="rentalapplicationdata.rentalHistory.cityStateZIP.currentResidence"
                      value={
                        formData.rentalapplicationdata.rentalHistory
                          .cityStateZIP.currentResidence
                      }
                      onChange={handleChange}
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="currentLandlord">Landlord/Manager</Label>
                    <Input
                      id="currentLandlord"
                      data-path="rentalapplicationdata.rentalHistory.landlordManager.currentResidence"
                      value={
                        formData.rentalapplicationdata.rentalHistory
                          .landlordManager.currentResidence
                      }
                      onChange={handleChange}
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="currentRentalPhone">Phone Number</Label>
                    <Input
                      id="currentRentalPhone"
                      type="tel"
                      data-path="rentalapplicationdata.rentalHistory.phoneNumber.currentResidence"
                      value={
                        formData.rentalapplicationdata.rentalHistory.phoneNumber
                          .currentResidence
                      }
                      onChange={handleChange}
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="currentPayment">Monthly Payment</Label>
                    <Input
                      id="currentPayment"
                      type="number"
                      data-path="rentalapplicationdata.rentalHistory.monthlyPayment.currentResidence"
                      value={
                        formData.rentalapplicationdata.rentalHistory
                          .monthlyPayment.currentResidence
                      }
                      onChange={handleChange}
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="currentRentalDates">Dates</Label>
                    <Input
                      id="currentRentalDates"
                      type="Date"
                      data-path="rentalapplicationdata.rentalHistory.dates.currentResidence"
                      value={
                        formData.rentalapplicationdata.rentalHistory.dates
                          .currentResidence
                      }
                      onChange={handleChange}
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="currentLeaving">Reason for Leaving</Label>
                    <Input
                      id="currentLeaving"
                      data-path="rentalapplicationdata.rentalHistory.leavingReason.currentResidence"
                      value={
                        formData.rentalapplicationdata.rentalHistory
                          .leavingReason.currentResidence
                      }
                      onChange={handleChange}
                    />
                  </div>
                </div>

                {/* Previous Residence */}
                <div className="space-y-4">
                  <h4 className="font-medium">Previous Residence</h4>
                  <div className="space-y-2">
                    <Label htmlFor="currentStreet">Street</Label>
                    <Input
                      id="currentStreet"
                      data-path="rentalapplicationdata.rentalHistory.street.previousResidence"
                      value={
                        formData.rentalapplicationdata.rentalHistory.street
                          .previousResidence
                      }
                      onChange={handleChange}
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="currentCityStateZip">
                      City, State, Zip
                    </Label>
                    <Input
                      id="currentCityStateZip"
                      data-path="rentalapplicationdata.rentalHistory.cityStateZIP.previousResidence"
                      value={
                        formData.rentalapplicationdata.rentalHistory
                          .cityStateZIP.previousResidence
                      }
                      onChange={handleChange}
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="currentLandlord">Landlord/Manager</Label>
                    <Input
                      id="currentLandlord"
                      data-path="rentalapplicationdata.rentalHistory.landlordManager.previousResidence"
                      value={
                        formData.rentalapplicationdata.rentalHistory
                          .landlordManager.previousResidence
                      }
                      onChange={handleChange}
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="currentRentalPhone">Phone Number</Label>
                    <Input
                      id="currentRentalPhone"
                      type="tel"
                      data-path="rentalapplicationdata.rentalHistory.phoneNumber.previousResidence"
                      value={
                        formData.rentalapplicationdata.rentalHistory.phoneNumber
                          .previousResidence
                      }
                      onChange={handleChange}
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="currentPayment">Monthly Payment</Label>
                    <Input
                      id="currentPayment"
                      type="number"
                      data-path="rentalapplicationdata.rentalHistory.monthlyPayment.previousResidence"
                      value={
                        formData.rentalapplicationdata.rentalHistory
                          .monthlyPayment.previousResidence
                      }
                      onChange={handleChange}
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="currentRentalDates">Dates</Label>
                    <Input
                      id="currentRentalDates"
                      type="Date"
                      data-path="rentalapplicationdata.rentalHistory.dates.previousResidence"
                      value={
                        formData.rentalapplicationdata.rentalHistory.dates
                          .previousResidence
                      }
                      onChange={handleChange}
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="currentLeaving">Reason for Leaving</Label>
                    <Input
                      id="currentLeaving"
                      data-path="rentalapplicationdata.rentalHistory.leavingReason.previousResidence"
                      value={
                        formData.rentalapplicationdata.rentalHistory
                          .leavingReason.previousResidence
                      }
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Additional Questions */}
            <div className="space-y-4">
              {/* Bankruptcy Section */}
              <div className="flex items-center justify-between gap-4">
                <Label htmlFor="bankruptcy">
                  Have you declared bankruptcy in the past seven (7) years?
                </Label>
                <div className="flex gap-4">
                  <div className="flex items-center gap-2">
                    <input
                      type="radio"
                      id="bankruptcyYes"
                      name="bankruptcy"
                      checked={
                        formData.rentalapplicationdata.rentalHistoryBool
                          .bankruptcy === true
                      }
                      onChange={() =>
                        setFormData((prev) => ({
                          ...prev,
                          rentalapplicationdata: {
                            ...prev.rentalapplicationdata,
                            rentalHistoryBool: {
                              ...prev.rentalapplicationdata.rentalHistoryBool,
                              bankruptcy: true, // Set bankruptcy to true when Yes is selected
                            },
                          },
                        }))
                      }
                    />
                    <Label htmlFor="bankruptcyYes">Yes</Label>
                  </div>
                  <div className="flex items-center gap-2">
                    <input
                      type="radio"
                      id="bankruptcyNo"
                      name="bankruptcy"
                      checked={
                        formData.rentalapplicationdata.rentalHistoryBool
                          .bankruptcy === false
                      }
                      onChange={() =>
                        setFormData((prev) => ({
                          ...prev,
                          rentalapplicationdata: {
                            ...prev.rentalapplicationdata,
                            rentalHistoryBool: {
                              ...prev.rentalapplicationdata.rentalHistoryBool,
                              bankruptcy: false, // Set bankruptcy to false when No is selected
                            },
                          },
                        }))
                      }
                    />
                    <Label htmlFor="bankruptcyNo">No</Label>
                  </div>
                </div>
              </div>

              {/* Felony Section */}
              <div className="flex items-center justify-between gap-4">
                <Label htmlFor="felony">
                  Have you ever been convicted of a felony?
                </Label>
                <div className="flex gap-4">
                  <div className="flex items-center gap-2">
                    <input
                      type="radio"
                      id="felonyYes"
                      name="felony"
                      checked={
                        formData.rentalapplicationdata.rentalHistoryBool
                          .convictedFelony === true
                      }
                      onChange={() =>
                        setFormData((prev) => ({
                          ...prev,
                          rentalapplicationdata: {
                            ...prev.rentalapplicationdata,
                            rentalHistoryBool: {
                              ...prev.rentalapplicationdata.rentalHistoryBool,
                              convictedFelony: true, // Set convictedFelony to true when Yes is selected
                            },
                          },
                        }))
                      }
                    />
                    <Label htmlFor="felonyYes">Yes</Label>
                  </div>
                  <div className="flex items-center gap-2">
                    <input
                      type="radio"
                      id="felonyNo"
                      name="felony"
                      checked={
                        formData.rentalapplicationdata.rentalHistoryBool
                          .convictedFelony === false
                      }
                      onChange={() =>
                        setFormData((prev) => ({
                          ...prev,
                          rentalapplicationdata: {
                            ...prev.rentalapplicationdata,
                            rentalHistoryBool: {
                              ...prev.rentalapplicationdata.rentalHistoryBool,
                              convictedFelony: false, // Set convictedFelony to false when No is selected
                            },
                          },
                        }))
                      }
                    />
                    <Label htmlFor="felonyNo">No</Label>
                  </div>
                </div>
              </div>

              {/* Eviction Section */}
              <div className="flex items-center justify-between gap-4">
                <Label htmlFor="evicted">
                  Have you ever been evicted from a rental residence?
                </Label>
                <div className="flex gap-4">
                  <div className="flex items-center gap-2">
                    <input
                      type="radio"
                      id="evictedYes"
                      name="evicted"
                      checked={
                        formData.rentalapplicationdata.rentalHistoryBool
                          .rentalResidence === true
                      }
                      onChange={() =>
                        setFormData((prev) => ({
                          ...prev,
                          rentalapplicationdata: {
                            ...prev.rentalapplicationdata,
                            rentalHistoryBool: {
                              ...prev.rentalapplicationdata.rentalHistoryBool,
                              rentalResidence: true,
                            },
                          },
                        }))
                      }
                    />
                    <Label htmlFor="evictedYes">Yes</Label>
                  </div>
                  <div className="flex items-center gap-2">
                    <input
                      type="radio"
                      id="evictedNo"
                      name="evicted"
                      checked={
                        formData.rentalapplicationdata.rentalHistoryBool
                          .rentalResidence === false
                      }
                      onChange={() =>
                        setFormData((prev) => ({
                          ...prev,
                          rentalapplicationdata: {
                            ...prev.rentalapplicationdata,
                            rentalHistoryBool: {
                              ...prev.rentalapplicationdata.rentalHistoryBool,
                              rentalResidence: false,
                            },
                          },
                        }))
                      }
                    />
                    <Label htmlFor="evictedNo">No</Label>
                  </div>
                </div>
              </div>

              {/* Late Payments Section */}
              <div className="flex items-center justify-between gap-4">
                <Label htmlFor="latePayments">
                  Have you had two or more late rental payments in the past
                  year?
                </Label>
                <div className="flex gap-4">
                  <div className="flex items-center gap-2">
                    <input
                      type="radio"
                      id="latePaymentsYes"
                      name="latePayments"
                      checked={
                        formData.rentalapplicationdata.rentalHistoryBool
                          .rentalPayment === true
                      }
                      onChange={() =>
                        setFormData((prev) => ({
                          ...prev,
                          rentalapplicationdata: {
                            ...prev.rentalapplicationdata,
                            rentalHistoryBool: {
                              ...prev.rentalapplicationdata.rentalHistoryBool,
                              rentalPayment: true,
                            },
                          },
                        }))
                      }
                    />
                    <Label htmlFor="latePaymentsYes">Yes</Label>
                  </div>
                  <div className="flex items-center gap-2">
                    <input
                      type="radio"
                      id="latePaymentsNo"
                      name="latePayments"
                      checked={
                        formData.rentalapplicationdata.rentalHistoryBool
                          .rentalPayment === false
                      }
                      onChange={() =>
                        setFormData((prev) => ({
                          ...prev,
                          rentalapplicationdata: {
                            ...prev.rentalapplicationdata,
                            rentalHistoryBool: {
                              ...prev.rentalapplicationdata.rentalHistoryBool,
                              rentalPayment: false,
                            },
                          },
                        }))
                      }
                    />
                    <Label htmlFor="latePaymentsNo">No</Label>
                  </div>
                </div>
              </div>

              {/* Rent Refusal Section */}
              <div className="flex items-center justify-between gap-4">
                <Label htmlFor="refusedRent">
                  Have you ever willfully or intentionally refused to pay rent?
                </Label>
                <div className="flex gap-4">
                  <div className="flex items-center gap-2">
                    <input
                      type="radio"
                      id="refusedRentYes"
                      name="refusedRent"
                      checked={
                        formData.rentalapplicationdata.rentalHistoryBool
                          .payRent === true
                      }
                      onChange={() =>
                        setFormData((prev) => ({
                          ...prev,
                          rentalapplicationdata: {
                            ...prev.rentalapplicationdata,
                            rentalHistoryBool: {
                              ...prev.rentalapplicationdata.rentalHistoryBool,
                              payRent: true,
                            },
                          },
                        }))
                      }
                    />
                    <Label htmlFor="refusedRentYes">Yes</Label>
                  </div>
                  <div className="flex items-center gap-2">
                    <input
                      type="radio"
                      id="refusedRentNo"
                      name="refusedRent"
                      checked={
                        formData.rentalapplicationdata.rentalHistoryBool
                          .payRent === false
                      }
                      onChange={() =>
                        setFormData((prev) => ({
                          ...prev,
                          rentalapplicationdata: {
                            ...prev.rentalapplicationdata,
                            rentalHistoryBool: {
                              ...prev.rentalapplicationdata.rentalHistoryBool,
                              payRent: false,
                            },
                          },
                        }))
                      }
                    />
                    <Label htmlFor="refusedRentNo">No</Label>
                  </div>
                </div>
              </div>
            </div>

            {/* Emergency Contacts */}
            <div>
              <h3 className="mb-4 text-lg font-semibold">
                Emergency Contact 1
              </h3>
              <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6">
                <div className="space-y-2">
                  <Label htmlFor="ec1FirstName">First Name</Label>
                  <Input
                    id="ec1FirstName"
                    data-path="rentalapplicationdata.emergencyContact1.firstName"
                    value={
                      formData.rentalapplicationdata.emergencyContact1.firstName
                    }
                    onChange={handleChange}
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="ec1LastName">Last Name</Label>
                  <Input
                    id="ec1LastName"
                    data-path="rentalapplicationdata.emergencyContact1.lastName"
                    value={
                      formData.rentalapplicationdata.emergencyContact1.lastName
                    }
                    onChange={handleChange}
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="ec1MI">M.I</Label>
                  <Input
                    id="ec1MI"
                    data-path="rentalapplicationdata.emergencyContact1.mi"
                    value={formData.rentalapplicationdata.emergencyContact1.mi}
                    onChange={handleChange}
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="ec1HomePhone">Home Phone</Label>
                  <Input
                    id="ec1HomePhone"
                    data-path="rentalapplicationdata.emergencyContact1.homePhone"
                    type="tel"
                    value={
                      formData.rentalapplicationdata.emergencyContact1.homePhone
                    }
                    onChange={handleChange}
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="ec1WorkPhone">Work Phone</Label>
                  <Input
                    id="ec1WorkPhone"
                    data-path="rentalapplicationdata.emergencyContact1.workPhone"
                    type="tel"
                    value={
                      formData.rentalapplicationdata.emergencyContact1.workPhone
                    }
                    onChange={handleChange}
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="ec1CellPhone">Cell Phone</Label>
                  <Input
                    id="ec1CellPhone"
                    data-path="rentalapplicationdata.emergencyContact1.cellPhone"
                    type="tel"
                    value={
                      formData.rentalapplicationdata.emergencyContact1.cellPhone
                    }
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            <div>
              <h3 className="mb-4 text-lg font-semibold">
                Emergency Contact 2
              </h3>
              <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6">
                <div className="space-y-2">
                  <Label htmlFor="ec2FirstName">First Name</Label>
                  <Input
                    id="ec2FirstName"
                    data-path="rentalapplicationdata.emergencyContact2.firstName"
                    value={
                      formData.rentalapplicationdata.emergencyContact2.firstName
                    }
                    onChange={handleChange}
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="ec2LastName">Last Name</Label>
                  <Input
                    id="ec2LastName"
                    data-path="rentalapplicationdata.emergencyContact2.lastName"
                    value={
                      formData.rentalapplicationdata.emergencyContact2.lastName
                    }
                    onChange={handleChange}
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="ec2MI">M.I</Label>
                  <Input
                    id="ec2MI"
                    data-path="rentalapplicationdata.emergencyContact2.mi"
                    value={formData.rentalapplicationdata.emergencyContact2.mi}
                    onChange={handleChange}
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="ec2HomePhone">Home Phone</Label>
                  <Input
                    id="ec2HomePhone"
                    data-path="rentalapplicationdata.emergencyContact2.homePhone"
                    type="tel"
                    value={
                      formData.rentalapplicationdata.emergencyContact2.homePhone
                    }
                    onChange={handleChange}
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="ec2WorkPhone">Work Phone</Label>
                  <Input
                    id="ec2WorkPhone"
                    data-path="rentalapplicationdata.emergencyContact2.workPhone"
                    type="tel"
                    value={
                      formData.rentalapplicationdata.emergencyContact2.workPhone
                    }
                    onChange={handleChange}
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="ec2CellPhone">Cell Phone</Label>
                  <Input
                    id="ec2CellPhone"
                    data-path="rentalapplicationdata.emergencyContact2.cellPhone"
                    type="tel"
                    value={
                      formData.rentalapplicationdata.emergencyContact2.cellPhone
                    }
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            {/* Authorization */}
            <div className="space-y-4">
              <h3 className="text-lg font-semibold">
                AUTHORIZATION FOR RELEASE OF INFORMATION
              </h3>
              <div className="space-y-4 rounded-lg border p-4 text-sm">
                <p>
                  I understand that this document is but the first step on the
                  winding path toward securing an apartment, yet it is no lease
                  or rental agreement, neither in part nor in full. I recognize
                  that every detail provided will be examined and credit reports
                  will be summoned from the shadows of financial history. I
                  pledge that each word inscribed here is honest and true.
                </p>
                <p>
                  By signing below, I open the door to an investigation—credit,
                  bank records, bank balances, and employment threads—all woven
                  together for the purpose of renting a space from New Leaf
                  Apartments. I grant permission for my past, both financial and
                  personal, to be brought into light, with any names I&apos;ve
                  listed being reached out to. I accept that any misstep or
                  absence of detail may cause this journey to end before it
                  begins.
                </p>
                <p>
                  I also acknowledge the non-refundable application fee, a cost
                  tethered to the process of reviewing my submission. Even if I
                  do not find my home here, I release claim to any return of
                  these funds. If questions arise from a rejected application, I
                  know they must be posed in written form, accompanied by a
                  stamped envelope ready to carry the answer back. Each adult,
                  18 years or older, must navigate their own application. The
                  cost is $50, with an additional $20 for every extra adult. The
                  final sum—application fee, security deposit, first
                  month&apos;s rent—must be carried in certified check or money
                  order, especially if paid within 15 days of the move-in date.
                </p>
                <div className="grid gap-4 pt-4 sm:grid-cols-2">
                  <div className="space-y-2">
                    <Label htmlFor="signature">Signature</Label>
                    <Input
                      id="signature"
                      name="signature"
                      data-path="rentalapplicationdata.authorizationReleaseInformation.signature"
                      value={
                        formData.rentalapplicationdata
                          .authorizationReleaseInformation.signature
                      }
                      onChange={handleChange}
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="signatureDate">Date</Label>
                    <Input
                      id="signatureDate"
                      type="date"
                      name="signatureDate"
                      data-path="rentalapplicationdata.authorizationReleaseInformation.date"
                      value={
                        formData.rentalapplicationdata
                          .authorizationReleaseInformation.date
                      }
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="flex items-center justify-end">
              <Button
                type="submit"
                disabled={loading}
                className="w-1/2 bg-[#7E22CE] hover:bg-purple-600"
              >
                {loading ? "Submitting..." : "Submit"}
              </Button>
            </div>
            <ToastContainer />
          </CardContent>
        </Card>
      </form>
    </div>
  );
}
